import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { supabaseClient } from "@/lib/supabase/client"

export default function AuthCallbackPage() {
  const navigate = useNavigate()
  useEffect(() => {
    supabaseClient.auth.getSession().then(() => navigate("/feed"))
  }, [])
  return <div className="min-h-screen bg-background flex items-center justify-center"><div className="skeleton-ig w-8 h-8 rounded-full" /></div>
}